import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Button,
  Stack
} from '@mui/material';
import CloseIcon from '../../../assets/icons/closeIcon.svg';

interface SimpleDialogProps {
  open: boolean;
  onClose: () => void;
  externalURL: string;
}

export const ExternalPopupModal = (props: SimpleDialogProps) => {
  const { onClose, open, externalURL } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: '400px',
          height: 'auto',
          borderRadius: '0.9375rem',
          padding: '0.9375rem',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }
      }}
    >
      <Button
        sx={{ justifyContent: 'end', padding: '0px' }}
        onClick={handleClose}
        data-testid={'#close-info-modal'}
      >
        <img src={CloseIcon} alt="Close Modal" />
      </Button>

      <DialogTitle
        id="alert-dialog-title"
        sx={{
          padding: '0px'
        }}
      >
        <Typography
          sx={{
            fontFamily: 'BGBold',
            fontSize: '1.5rem',
            lineHeight: '1.75rem',
            fontWeight: 'bold',
            color: '#002A3A',
            textAlign: 'center'
          }}
        >
          PLEASE NOTE
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          overflow: 'hidden',
          display: 'flex',
          justifyContent: 'center',
          marginTop: '0.9375rem',
          padding: '0px'
        }}
      >
        <DialogContentText id="alert-dialog-description">
          <Typography
            sx={{
              fontFamily: 'Calibri',
              fontSize: '1rem',
              lineHeight: '1.25rem',
              fontWeight: '450',
              color: '#002A3A',
              textAlign: 'center'
            }}
          >
            The link opens a window to another website. Please click
            <span
              style={{ fontWeight: 'bold', color: '#007ACC' }}
            >{` OK `}</span>
            to confirm or
            <span
              style={{ fontWeight: 'bold', color: '#007ACC' }}
            >{` CANCEL `}</span>
            to remain within the{' '}
            <span style={{ fontStyle: 'italic' }}>Abbott Nutrition App.</span>
          </Typography>
        </DialogContentText>
      </DialogContent>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '1.875rem'
        }}
      >
        <Button
          variant="outlined"
          sx={{
            border: '0.125rem solid #007ACC',
            borderRadius: '100px',
            color: '#007ACC'
          }}
          onClick={handleClose}
        >
          CANCEL
        </Button>
        <Button
          variant="outlined"
          sx={{
            border: '0.125rem solid #007ACC',
            borderRadius: '100px',
            color: '#fff',
            background: '#007ACC'
          }}
          href={externalURL}
        >
          OK
        </Button>
      </Stack>
    </Dialog>
  );
};
